var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.98 11L24 8.98C20.93 5.9 16.69 4 12 4C7.31 4 3.07 5.9 0 8.98L6.35 15.34L12 21L15.05 17.95V15C15.05 14.55 15.14 14.12 15.28 13.71C15.82 12.14 17.29 11 19.05 11H21.98Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.8182V15.9091L21.5 14.4545L20 13V14.0909C18.3425 14.0909 17 15.3927 17 17C17 17.5709 17.1725 18.1018 17.465 18.5491L18.0125 18.0182C17.8437 17.7164 17.75 17.3673 17.75 17C17.75 15.7964 18.7588 14.8182 20 14.8182ZM22.535 15.4509L21.9875 15.9818C22.1525 16.2873 22.25 16.6327 22.25 17C22.25 18.2036 21.2412 19.1818 20 19.1818V18.0909L18.5 19.5455L20 21V19.9091C21.6575 19.9091 23 18.6073 23 17C23 16.4291 22.8275 15.8982 22.535 15.4509Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiRefresh);
export default __webpack_public_path__ + "static/media/WifiRefresh.ea3c299aa3fe3737cab1558e051a2fd0.svg";
export { ForwardRef as ReactComponent };